import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

function PaddedComponent({ children }) {
  return <div className={styles.paddingTop}>{children}</div>;
}

PaddedComponent.propTypes = {
  children: PropTypes.node,
};

export default PaddedComponent;
